import React from 'react';
import { List, Segment } from 'semantic-ui-react';
import { injectIntl } from 'react-intl';


const Footer = ({ intl }) => {
    const currentYear = new Date().getFullYear();

    return (
        <Segment role="contentinfo" padded id="footer">
            <div className="footerTop">
                <List className="footerList">
                    <p className="item list-title">Öffnungszeiten</p>

                    <div role="listitem">
                        <p className="item list-title-small">Dienstag - Freitag</p>
                        <p className="item">09:00 - 12:00; 13:30 - 18:00</p>
                    </div>

                    <div role="listitem">
                        <p className="item list-title-small">Samstag</p>
                        <p className="item">09:00 - 14:00</p>
                    </div>
                </List>

                <List className="footerList">
                    <p className="item list-title">Adresse</p>
                    
                    <p className="item">Multimedia Kompetenz Zentrum Langnau</p>
                    <p className="item">Bahnhofstrasse 15</p>
                    <p className="item">3550 Langnau i. E.</p>
                </List>

                <List className="footerList">
                    <p className="item list-title">Kontakt</p>

                    <a href='tel:+41344083430' className="item">034 408 34 30</a>
                    <a href='mailto:info@multimedia-langnau.ch' className="item">info@multimedia-langnau.ch</a>

                    <a className="item socialIcon" href="https://www.instagram.com/elektroliechtiag" target="_blank">
                        <i className="ri-instagram-line"></i>
                    </a>
                </List>
            </div>
            <hr />
            <div className='footerBottom'>
                <List className="footerList">
                    <a className="item item-bottom" href="./impressum">Impressum</a>
                    <a className="item item-bottom" href="./datenschutz">Datenschutzerklärung</a>

                    <div role="listitem" className="item item-bottom">
                        <i className="ri-copyright-line"></i> {currentYear} Elektro Liechti AG, Langnau
                    </div>
                </List>
            </div>
        </Segment>
    );
};

export default injectIntl(Footer);